export default __webpack_public_path__ + "static/media/governance.c9c154ab.png";